import SectionCard from "components/cms/SectionCard";
import {
  CardRow,
  FieldRow,
  FileInput,
  GroupBox,
  TextInput,
} from "components/cms/fields";

const FACTS = ["heroFact1", "heroFact2", "heroFact3", "heroFact4"];

export const PHOTO_HERO_KEYS = [
  "heroBackground",
  "heroTag",
  "heroTitle1",
  "heroTitle2",
  "heroPrimaryCtaText",
  "heroPrimaryCtaLink",
  "heroSecondaryCtaText",
  "heroSecondaryCtaLink",
  "heroFact1",
  "heroFact2",
  "heroFact3",
  "heroFact4",
  "heroSectionHide",
];

export default function PhotoHeroStack({
  form,
  setField,
  frMap,
  hideId,
  onSave,
  saving,
  canSave,
}) {
  return (
    <SectionCard
      title="Hero"
      hide={form.heroSectionHide}
      hideId={hideId}
      onHideChange={(value) => setField("heroSectionHide", value)}
      onSave={onSave}
      saving={saving}
      canSave={canSave}
    >
      <FileInput
        label="Background"
        path="heroBackground"
        form={form}
        setField={setField}
        extra="max-w-xl"
      />
      <FieldRow>
        <TextInput label="Tag" path="heroTag" form={form} setField={setField} frMap={frMap} />
      </FieldRow>
      <FieldRow>
        <TextInput
          label="Title line 1"
          path="heroTitle1"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <TextInput
          label="Title line 2"
          path="heroTitle2"
          form={form}
          setField={setField}
          frMap={frMap}
        />
      </FieldRow>
      <FieldRow>
        <TextInput
          label="Primary CTA text"
          path="heroPrimaryCtaText"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <TextInput
          label="Primary CTA link"
          path="heroPrimaryCtaLink"
          form={form}
          setField={setField}
        />
      </FieldRow>
      <FieldRow>
        <TextInput
          label="Secondary CTA text"
          path="heroSecondaryCtaText"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <TextInput
          label="Secondary CTA link"
          path="heroSecondaryCtaLink"
          form={form}
          setField={setField}
        />
      </FieldRow>
      <CardRow>
        {FACTS.map((key, index) => (
          <GroupBox key={key} title={`Fact ${index + 1}`}>
            <TextInput
              label="Label"
              path={`${key}.label`}
              form={form}
              setField={setField}
              frMap={frMap}
            />
            <TextInput
              label="Value"
              path={`${key}.value`}
              form={form}
              setField={setField}
              frMap={frMap}
            />
          </GroupBox>
        ))}
      </CardRow>
    </SectionCard>
  );
}
